"use client"

import { createContext, useContext } from "react"

const ApartContext = createContext()

export const useApartContext = () => {
  const context = useContext(ApartContext)
  if (!context) {
    throw new Error("useApartContext must be used within an ApartContextProvider")
  }
  return context
}

const ApartContextProvider = ({ children }) => {
  const apartmentData = {
    id: 1,
    titleEn: "✨J Tower Luxury Suite✨",
    titleEs: "✨J Tower Luxury Suite✨",
    titleFr: "✨J Tower Luxury Suite✨",
    titleHe: "✨סוויטת - J Tower Luxury✨",
    internalCode: "(H85)",
    descriptionEn: "Spacious 3-Bedroom Apartment with Stunning Jerusalem View – Steps from Mahane Yehuda Market.",
    descriptionEs: "Amplio apartamento de 3 dormitorios con impresionantes vistas a Jerusalén, a pasos del mercado Mahane Yehuda.",
    descriptionFr: "Spacieux appartement de 3 chambres avec vue imprenable sur Jérusalem – à quelques pas du marché Mahane Yehuda.",
    descriptionHe: "דירת 3 חדרי שינה מרווחת עם נוף מרהיב לירושלים – צעדים ספורים משוק מחנה יהודה.",
    longDescriptionEn: "Welcome to your home away from home in the heart of Jerusalem!\n\nThis beautifully designed 3-bedroom apartment with a large living room offers the perfect combination of comfort, convenience, and breathtaking views. Located just a minute's walk from the vibrant Mahane Yehuda Market, and right next to the light rail station, supermarkets, cafés, and public transportation – everything you need is just outside your door.\n\nEnjoy panoramic views of Jerusalem from the apartment's windows and balcony – especially stunning at sunset, when the city lights begin to glow.",
    longDescriptionEs: "¡Bienvenido a su hogar lejos del hogar en el corazón de Jerusalén!\n\nEste apartamento de 3 dormitorios bellamente diseñado con una amplia sala de estar ofrece la combinación perfecta de comodidad, conveniencia y vistas impresionantes. Ubicado a solo un minuto a pie del vibrante mercado Mahane Yehuda, y justo al lado de la estación de tren ligero, supermercados, cafés y transporte público - todo lo que necesita está justo fuera de su puerta.\n\nDisfrute de vistas panorámicas de Jerusalén desde las ventanas y el balcón del apartamento - especialmente impresionantes al atardecer, cuando las luces de la ciudad comienzan a brillar.",
    longDescriptionFr: "Bienvenue dans votre maison loin de chez vous au cœur de Jérusalem!\n\nCet appartement de 3 chambres magnifiquement conçu avec un grand salon offre la combinaison parfaite de confort, de commodité et de vues à couper le souffle. Situé à une minute à pied du vibrant marché Mahane Yehuda, et juste à côté de la station de tramway, des supermarchés, des cafés et des transports en commun - tout ce dont vous avez besoin est juste devant votre porte.\n\nProfitez des vues panoramiques de Jérusalem depuis les fenêtres et le balcon de l'appartement - particulièrement magnifiques au coucher du soleil, lorsque les lumières de la ville commencent à briller.",
    longDescriptionHe: "ברוכים הבאים לבית שלכם בירושלים!\n\nהדירה המרווחת עם 3 חדרי שינה וסלון גדול מציעה נוחות, נגישות ונוף עוצר נשימה. רק דקה הליכה משוק מחנה יהודה הססגוני, ולצד תחנת הרכבת הקלה, סופרמרקטים, בתי קפה ותחבורה ציבורית – הכל ממש לידכם.\n\nתיהנו מנוף פנורמי של ירושלים מהחלונות ומהמרפסת – במיוחד בשקיעה כשאורות העיר נדלקים.",
    size: 100,
    guests: 6,
    bedrooms: 3,
    bathrooms: 2,
    images: [
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569113/Apart_1_1_xswrrj.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569113/Apart_1_2_zzlntr.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569113/Apart_1_3_wu2tdp.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569114/Apart_1_4_hnsa3y.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569113/Apart_1_5_nycl5p.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569113/Apart_1_6_zsurth.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569113/Apart_1_7_zsmxao.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569114/Apart_1_8_kus1kl.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569115/Apart_1_9_yr85bi.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569114/Apart_1_10_ohvl9j.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569114/Apart_1_11_ryvelc.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569115/Apart_1_12_gkf9pl.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569116/Apart_1_13_kgmuun.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569116/Apart_1_14_sgl6ry.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569116/Apart_1_15_gikrtv.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569116/Apart_1_16_nraby2.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569116/Apart_1_17_oripjm.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569117/Apart_1_18_dauf9f.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569117/Apart_1_19_tppby2.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569117/Apart_1_20_sdp2j5.png",
      "https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569118/Apart_1_21_xqgiql.png"
    ],
    amenities: [
      { name: "Fully Equipped Kitchen", nameEs: "Cocina Totalmente Equipada", nameFr: "Cuisine Entièrement Équipée", nameHe: "מטבח מאובזר", icon: "kitchen" },
      { name: "Air Conditioning", nameEs: "Aire Acondicionado", nameFr: "Climatisation", nameHe: "מיזוג אוויר", icon: "air" },
      { name: "Smart TV", nameEs: "Smart TV", nameFr: "Smart TV", nameHe: "טלוויזיה חכמה", icon: "tv" },
      { name: "High-Speed Wi-Fi", nameEs: "Wi-Fi de Alta Velocidad", nameFr: "Wi-Fi Haut Débit", nameHe: "אינטרנט אלחוטי מהיר", icon: "wifi" },
      { name: "Washing Machine", nameEs: "Lavadora", nameFr: "Machine à Laver", nameHe: "מכונת כביסה", icon: "washer" },
      { name: "Nespresso Machine", nameEs: "Máquina Nespresso", nameFr: "Machine Nespresso", nameHe: "מכונת נספרסו", icon: "coffee" },
      { name: "Fresh Linens & Towels", nameEs: "Sábanas y Toallas Limpias", nameFr: "Draps et Serviettes Frais", nameHe: "מצעים ומגבות נקיים", icon: "bed" },
      { name: "Hairdryer", nameEs: "Secador de Pelo", nameFr: "Sèche-cheveux", nameHe: "מייבש שיער", icon: "hairdryer" },
      { name: "Iron", nameEs: "Plancha", nameFr: "Fer à Repasser", nameHe: "מגהץ", icon: "iron" },
      { name: "Dryer", nameEs: "Secadora", nameFr: "Sèche-linge", nameHe: "מייבש כביסה", icon: "dryer" }
    ],
    location: {
      addressEn: "103 Jaffa Street, Jerusalem",
      addressEs: "103 Calle Jaffa, Jerusalén",
      addressFr: "103 Rue Jaffa, Jérusalem",
      addressHe: "רחוב יפו 103, ירושלים",
      addressDescEn: "Near Mahane Yehuda Market, Jerusalem",
      addressDescEs: "Cerca del Mercado Mahane Yehuda, Jerusalén",
      addressDescFr: "Près du marché Mahane Yehuda, Jérusalem",
      addressDescHe: "קרוב לשוק מחנה יהודה, ירושלים",
      coordinates: {
        lat: 31.7857,
        lng: 35.2124
      },
      highlights: [
        {
          nameEn: "1-minute walk to Mahane Yehuda Market",
          nameEs: "A 1 minuto a pie del Mercado Mahane Yehuda",
          nameFr: "1 minute à pied du marché Mahane Yehuda",
          nameHe: "דקה הליכה לשוק מחנה יהודה"
        },
        {
          nameEn: "Light rail station directly across the street",
          nameEs: "Estación de tren ligero justo al otro lado de la calle",
          nameFr: "Station de tramway directement en face",
          nameHe: "תחנת הרכבת הקלה ממש מול הבניין"
        },
        {
          nameEn: "Surrounded by shops, supermarkets, restaurants, and cafés",
          nameEs: "Rodeado de tiendas, supermercados, restaurantes y cafés",
          nameFr: "Entouré de magasins, supermarchés, restaurants et cafés",
          nameHe: "מוקף חנויות, סופרמרקטים, מסעדות ובתי קפה"
        },
        {
          nameEn: "Easy access to all major attractions in Jerusalem",
          nameEs: "Fácil acceso a todas las principales atracciones de Jerusalén",
          nameFr: "Accès facile à toutes les principales attractions de Jérusalem",
          nameHe: "גישה נוחה לכל האטרקציות המרכזיות בירושלים"
        }
      ]
    }
  };

  return (
    <ApartContext.Provider value={{ apartmentData }}>
      {children}
    </ApartContext.Provider>
  )
}

export default ApartContextProvider
